export default __webpack_public_path__ + "static/media/shopify.18e3f0c0.png";